<template>
  <div :class="layoutType" class="pb-5 min-vh-100">
    <HeaderPc style="min-height:auto;" />
    <!-- header begin -->
    <div class="container py-4">
      <h1 class="h3 text-mcf-color">{{ title }}</h1>
    </div>
    <!-- header end -->
    <div class="container">
      <b-tabs class="h-100 te-tabs-mcf" :class="{'nav-tabs-light': layoutType === 'mcf-dark'}" content-class="mt-4 font-size-md" nav-class="w-50 mx-auto d-none" justified><!-- 黑夜模式時nav要加nav-tabs-light -->
        <!-- tab-兌禮清單 begin -->
        <b-tab active>
          <template v-slot:title>
          </template>
          <div class="py-3 px-5 mb-5 mx-auto bg-white rounded-md" style="max-width:680px;">
            <RedeemCartList ref="cart" @changeBuyStatus="changeBuyStatus" class="mb-5" />
            <div class="d-flex justify-content-center">
              <b-button @click="$router.push({ name: 'redeemList', query: { companyid: $store.state.companyId, membersourceid: $store.state.memberSourceId }})" size="sm" class="bg-customize border-customize d-block w-25 my-3 mx-2 font-size-md">{{ backButtonWording }}</b-button>
              <b-button :disabled="!canPlaceOrder" @click="submit" size="sm" :style="confirmButtonStyle" class="bg-customize border-customize d-block w-25 my-3 mx-2 font-size-md">{{ $t('global.confirm') }}</b-button>
            </div>
          </div>
        </b-tab>
        <!-- tab-兌禮清單 end -->
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HeaderPc from '@/components/HeaderPc.vue';
import RedeemCartList from '@/components/redeem/RedeemCartList.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    HeaderPc,
    RedeemCartList,
  },
  data() {
    return {
      // 標題
      title: '',
      // 可下單
      canPlaceOrder: false,
      // 回列表頁按鈕文案
      backButtonWording: '',
    };
  },
  computed: {
    ...mapState(['layoutType']),
    // 確認按鈕 Style
    confirmButtonStyle() {
      const vm = this;
      // 不可下單就不要有cursor
      return vm.canPlaceOrder ? '' : 'cursor: default;';
    },
  },
  methods: {
    // 變更購買狀態
    changeBuyStatus(newStatus) {
      this.canPlaceOrder = newStatus;
    },
    // 送出訂單
    submit() {
      this.$refs.cart.buyConfirm();
    },
  },
  created() {
    const vm = this;
    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
        // 回列表頁按鈕文案
        vm.backButtonWording = pageSettingGetter.getFunctionWording(setting, 'CartBackToShopButton');
      });
  },
};
</script>
